import { useEffect, useState } from 'react'

export const usePathOffsetTop = (svgRef, controlElementRef) => {
	const [offsetTop, setOffsetTop] = useState(0)

	useEffect(() => {
		if (!svgRef.current || !controlElementRef.current) return

		const svg = svgRef.current
		const element = controlElementRef.current
		const svgBounds = svg.getBoundingClientRect()
		const elementBBox = element.getBBox()

		const helperPoint = svg.createSVGPoint()
		helperPoint.x = 0
		helperPoint.y = elementBBox.y
		const topPoint = helperPoint.matrixTransform(svg.getScreenCTM())

		setOffsetTop(topPoint.y - svgBounds.top)
	}, [svgRef, controlElementRef])

	return offsetTop
}
